/**
 * Liens externes institutionnels. Valeurs publiques et stables sur tous les
 * environnements : constantes plutôt que variables d'environnement.
 */
export const ExternalLinks = {
  MentionsLegales: 'https://www.hellio.com/mentions-legales',
  Cgu: 'https://www.hellio.com/cgu',
  PolitiqueConfidentialite: 'https://www.hellio.com/politique-confidentialite',
  Reglementaire:
    'https://www.ecologie.gouv.fr/politiques-publiques/' +
    'dispositif-certificats-deconomies-denergie',
} as const;

export default ExternalLinks;
